"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _core = require("@material-ui/core");

var _excluded = ["className", "children"];

var styles = function styles(theme) {
  return {
    root: theme.mixins.gutters({}),
    rounded: {
      borderRadius: 10
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/**
 * The root of a conceptual section.
 */

var Paper = function Paper(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.Paper, (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])(classes.root, classes.rounded, className)
  }), children);
};

Paper.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = Paper;
exports["default"] = _default;